/**
 * Skeleton-компонент начальной загрузки для клиента.
 */
export function LoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 px-4 pb-24">
      <div className="max-w-lg mx-auto space-y-6">
        {/* Skeleton статуса */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse" />
          </div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-3/4 mx-auto" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/2 mx-auto" />
          <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse w-full" />
        </div>

        {/* Skeleton деталей */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm space-y-4">
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/3" />
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-full" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-5/6" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-2/3" />
          </div>
          <div className="border-t border-gray-200 dark:border-gray-700 pt-4 space-y-3">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-full" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-full" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-3/4" />
          </div>
        </div>

        {/* Skeleton автообновления */}
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-1/3 mx-auto" />
      </div>
    </div>
  );
}
